import React from "react";
import { AbsoluteFill, Sequence, OffthreadVideo, Audio, Img, useCurrentFrame, interpolate } from "remotion";
import { KaraokeCaptions } from "../../../Common/KaraokeCaptions";

export const OutroSlide = ({
  item,
  theme,
  ENABLE_AUDIO = true,
  brand,
  backgroundVideo,
  pexelsCredit,
}) => {
  const frame = useCurrentFrame();
  const pan = interpolate(frame, [0, 150], [0, -50]);

  const videoSrc = backgroundVideo || "https://www.pexels.com/download/video/34623325/";

  const audioOffset = item.audioDelay || 0;

  const watermarkOpacity = interpolate(
    frame - audioOffset,
    [0, 30],     
    [0, 0.6],    
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );

  return (
    <AbsoluteFill style={{ backgroundColor: "#0f172a" }}>
      {ENABLE_AUDIO && item.props?.audioUrl && (
        <Sequence from={item.audioDelay || 0}>
          <Audio src={item.props.audioUrl} />
        </Sequence>
      )}

      {/* VIDEO BG */}
      <AbsoluteFill
        style={{
          maskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 30%, rgba(0,0,0,0.25) 55%)",
          WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 30%, rgba(0,0,0,0.25) 55%)",
          height: "100%",
          zIndex: 1,
        }}
      >
        <OffthreadVideo 
          src={videoSrc}
          muted={true}
          style={{
            width: "100%",
            height: "120%",
            objectFit: "cover",
            transform: `translateY(${pan}px)`,
          }}
        />
      </AbsoluteFill>

      {/* THE ATTRIBUTION OVERLAY (Moved to Safe Zone Left) */}
      {pexelsCredit && (
        <AbsoluteFill
          style={{
            zIndex: 10, 
            justifyContent: "flex-end",
            alignItems: "flex-start",
            paddingBottom: 220, // High enough to clear TikTok descriptions
            paddingLeft: 60,
          }}
        >
          <div style={{ transform: "translateZ(0)" }}>
            <p
              style={{
                color: "rgba(255, 255, 255, 0.5)",
                fontFamily: theme.fontMain,
                fontSize: 15,
                margin: 0,
                fontWeight: 400,
                letterSpacing: 1,
                textTransform: "uppercase",
                textShadow: "0px 2px 4px rgba(0,0,0,0.5)",
              }}
            >
              {pexelsCredit} / Pexels
            </p>
          </div>
        </AbsoluteFill>
      )}

      {/* CONTENT */}
      <AbsoluteFill
        style={{
          zIndex: 3,
          justifyContent: "center", // Centered vertically for portrait
          alignItems: "center",
          padding: "0 60px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Img
            src="https://firebasestorage.googleapis.com/v0/b/freelancer-ideas-portal.firebasestorage.app/o/adaptation_engine%2Fbrand_assets%2Floveinc.png?alt=media&token=22866cd2-1b3b-4c74-9e24-762e6cfd2c33"
            style={{
              height: 100,
              width: "auto",
              marginBottom: 40,
              opacity: 0.9,
              filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.6))"
            }}
          />
          <h1
            style={{
              color: "white",
              fontFamily: theme.fontDisplay || theme.fontMain,
              fontSize: 110, // Scaled down for mobile
              lineHeight: 0.9,
              margin: "0 0 20px 0",
              textTransform: "uppercase",
              textShadow: "0 10px 30px rgba(0,0,0,0.5)",
            }}
          >
            {item.text || "READ MORE"}
          </h1>

          {/* KARAOKE */}
          {item.captions && item.captions.length > 0 && (
            <div style={{
              width: "100%",
              height: 350, // 🔒 THE RIGID BOUNDING BOX: Absorbs up to 3-4 lines of 75px text without reflowing siblings
              marginBottom: 30,
              paddingTop: "10px",
              fontSize: 75,
              fontFamily: theme.fontMain,
              display: 'flex',
              alignItems: 'center', // Locks the dynamic text block vertically centered within the box
              justifyContent: 'center',
              flexShrink: 0,
              willChange: "transform, opacity",
            }}>
              <KaraokeCaptions
                captions={item.captions}
                theme={theme}
                delay={item.audioDelay || 0}
                align="center" // 💉 THE FLEX PROP: Maps to the internal component to center typography
              />
            </div>
          )}

          {/* BRAND LOCKUP (Moved to Safe Zone Left) */}
          <div
            style={{
              position: "absolute",
              bottom: 250, 
              left: 60,  
              zIndex: 9,
              opacity: watermarkOpacity, 
              willChange: "opacity",
            }}
          >
            <h3
              style={{
                color: "white",
                fontFamily: theme.fontMain,
                fontWeight: 700, 
                letterSpacing: 4,
                margin: 0,
                fontSize: 50,
                textShadow: "0px 4px 15px rgba(0,0,0,0.9)", 
              }}
            >
              LOVE{brand ? brand.toUpperCase() : "INC"}
            </h3>
          </div>

          <h3
            style={{
              color: "cyan",
              fontFamily: theme.fontMain,
              fontWeight: 500,
              letterSpacing: 4,
              margin: 0,
              fontSize: 30,
              textTransform: "uppercase",
              marginTop: 40
            }}
          >
            LIKE AND FOLLOW FOR MORE!
          </h3>
        </div>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};